export const apiMethods = (appUrl) => {
    return [
        {
            name: 'PlayerLogin',
            method: () => {
                return 'player/login';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'login_type',
                    processArgs: (val) => {
                        return 'desktop';
                    },
                },
                {
                    name: 'remember',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'PlayerLoginWithPTA',
            method: () => {
                return 'player/login';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'hash',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'login_type',
                    processArgs: (val) => {
                        return 'desktop';
                    },
                },
                {
                    name: 'remember',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'pta_version',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'PlayerLoginPTAV1',
            method: () => {
                return 'player/login';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'pta_version',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'playerID',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'firstName',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'lastName',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'address1',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'address2',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'city',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'stateAbbr',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'zip',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'dob',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'phonenumber',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'chksum',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'PlayerLoginPTAV2',
            method: () => {
                return 'player/login';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'pta_version',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'hash',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'iv',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'data',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'getSpatWithJwt',
            method: () => {
                return 'player/spat';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'CTLRegister',
            method: () => {
                return 'player/register';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm_email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'optins',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLUpdate',
            method: () => {
                return 'player/update';
            },
            action: 'put',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'address',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'agegate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'old_password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'firstname',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'lastname',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'birthdate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'gender',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'phone',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'remember',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLVerify',
            method: () => {
                return 'player/verify';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'address',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'birthdate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'firstname',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'lastname',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'gender',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'phone',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'ssn',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'registrar_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLConfirm',
            method: () => {
                return 'player/account/confirm';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'passcode',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'registrar_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLConfirmResend',
            method: () => {
                return 'player/account/confirm/resend';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'registrar_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'SCLConfirmResend',
            method: () => {
                return 'player/account/confirm/resend';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLForgotPassword',
            method: () => {
                return 'password/forgot';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLRecoverPassword',
            method: (urlArgs) => {
                return `password/forgot/${urlArgs.passcode}`;
            },
            action: 'put',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [
                {
                    name: 'passcode',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'DeletePlayerAccount',
            method: () => {
                return 'player/account/delete';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'CTLBandog',
            method: () => {
                return 'query/carousel/banners';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'size',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'EnterTicket',
            method: () => {
                return 'ticket/enter';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CTLEnterTicket',
            method: () => {
                return 'ticket/enter';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CheckTicketLoggedIn',
            method: () => {
                return 'ticket/check';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CheckTicketLoggedOut',
            method: () => {
                return 'ticket/check';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'device_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'hash',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetCoupons',
            method: () => {
                return 'query/playerCoupons';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'sku',
                    processArgs: (val) => {
                        return val ? val : null;
                    },
                },
                {
                    name: 'lottery_product',
                    processArgs: (val) => {
                        return val ? val : null;
                    },
                },
                {
                    name: 'state',
                    processArgs: (val) => {
                        return val ? val : null;
                    },
                },
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val ? val : 1;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetThirdPartyPrizes',
            method: () => {
                return 'query/thirdPartyPrizes';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'state',
                    processArgs: (val) => {
                        return val ? val : null;
                    },
                },
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val ? val : 1;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetThirdPartyPrizeBarcode',
            method: (urlArgs) => {
                return `query/thirdPartyPrizes/${urlArgs.barcode}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'barcode',
                    processArgs: (val) => {
                        return val ? val : null;
                    },
                },
            ],
        },
        {
            name: 'GetRewards',
            method: () => {
                return 'query/rewards';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val ? val : 1;
                    },
                },
                {
                    name: 'startdate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'enddate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'currency',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'signal',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetPoints',
            method: () => {
                return 'player/balances/points';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'limit',
                    processArgs: (val) => {
                        return 'award';
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetPlayerData',
            method: () => {
                return 'player/spat/refresh';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPlayerDataRam',
            method: () => {
                return 'player';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetActivity',
            method: () => {
                return 'query/activity';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetPromotions',
            method: () => {
                return 'query/promotions';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPlayerPromotions',
            method: () => {
                return 'query/promotions';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetLotteryPromotions',
            method: () => {
                return 'promotionsapi';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPointsForDrawings',
            method: () => {
                return 'pfd/getActivePlayerEntries';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPlayerPFDTransactions',
            method: () => {
                return 'pfd/transactions';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val ? val : 1;
                    },
                },
                {
                    name: 'sweeps_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'page_size',
                    processArgs: (val) => {
                        return val ? val : 5;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'RedeemPFDPoints',
            method: () => {
                return 'pfd/enterSweeps';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'transaction_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'account',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'points',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'quantity',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'sweeps_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'sweeps_name',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetPointsForDrawingsNoAuth',
            method: () => {
                return 'pfd/getActiveSweeps';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetFeedbackCategories',
            method: () => {
                return 'feedback/categories';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'Feedback',
            method: () => {
                return 'feedback';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'ConnectionSpeed',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'EmailAddress',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'FirstName',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'FlashVersion',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueCategory',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueDay',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueDescription',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueMonth',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueType',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueYear',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'IssueZone',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'LastName',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'Phone',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'Promotion',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'ZipCode',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetSweeps',
            method: (urlArgs) => {
                return `query/sweepstake/entries/activeplayer${urlArgs.sweeps_id}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'sweeps_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'GetSweepsByName',
            method: (urlArgs) => {
                return `query/sweepstake/entries/activeplayer?name=${urlArgs.name}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'GetSweepsNoAuth',
            method: () => {
                return 'sweepstake/active';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetCurrentSweeps',
            method: () => {
                return 'sweepstake/current';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetExpiredSweeps',
            method: () => {
                return `sweepstake/expired`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
            ],
        },
        {
            name: 'GetSweepDetails',
            method: (urlArgs) => {
                return `query/sweepstake/${urlArgs.sweeps_id}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [
                {
                    name: 'sweeps_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'GetSweepDetailsByName',
            method: (urlArgs) => {
                return `query/sweepstake?name=${urlArgs.name}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'AllocateEntries',
            method: (urlArgs) => {
                return `sweepstake/${urlArgs.sweepstake_id}/entry/${urlArgs.entry_id}/allocate`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    // This is an array - just process with no name.
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [
                {
                    name: 'sweepstake_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'GetPlayerAllocatableEntries',
            method: () => {
                return `sweepstake/entry/allocatable`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'Winners',
            method: (urlArgs) => {
                return `sweepstake/drawing/${urlArgs.drawing_id}/winners`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'drawing_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'WinnersNoAuth',
            method: (urlArgs) => {
                return `sweepstake/drawing/${urlArgs.drawing_id}/winners`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [
                {
                    name: 'drawing_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'ExpiredDrawings',
            method: (urlArgs) => {
                return `sweepstake/drawing/expired`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
                {
                    name: 'entry_type',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'ExpiredDrawingsAll',
            method: () => {
                return `sweepstake/drawing/expired`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
                {
                    name: 'entry_type',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CurrentDrawings',
            method: (urlArgs) => {
                return `drawings/current`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'entry_type',
                    processArgs: (val) => {
                        return val || 'promotion';
                    },
                },
            ],
            urlArgs: [
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
            ],
        },
        {
            name: 'CTLCurrentDrawings',
            method: () => {
                return `drawings/current`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'entry_type',
                    processArgs: (val) => {
                        return val || 'promotion';
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetConfig',
            method: () => {
                return 'config/frontend';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetRevealToken',
            method: () => {
                return 'reveal/authtoken';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetJackpotRoll',
            method: (urlArgs) => {
                return `jackpot${urlArgs.jackpot_id}/roll${urlArgs.jackpot_name}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [
                {
                    name: 'jackpot_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
                {
                    name: 'jackpot_name',
                    processArgs: (val) => {
                        return val ? '?name=' + val : '';
                    },
                },
            ],
        },
        {
            name: 'MRBRegister',
            method: () => {
                return 'player/register';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm_email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm',
                    processArgs: (val) => {
                        return val;
                    },
                },

                {
                    name: 'rafcode',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'optins',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetAllOptins',
            method: () => {
                return 'player/optins/all';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetOptinsByCategory',
            method: () => {
                return 'player/optins/bycontext';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetOptins',
            method: () => {
                return 'player/optins';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'OptinSubscribe',
            method: (urlArgs) => {
                return `player/optins/subscribe/${urlArgs.notification_id}`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'channel',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'filter',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [
                {
                    name: 'notification_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'OptinUnsubscribe',
            method: (urlArgs) => {
                return `player/optins/unsubscribe/${urlArgs.notification_id}/${urlArgs.subscription_id}`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'notification_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'subscription_id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'UpdateOptins',
            method: () => {
                return 'player/update';
            },
            action: 'put',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'optins',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetRafCode',
            method: () => {
                return 'refer/referrer/code';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'SendRafInvite',
            method: () => {
                return 'refer/invite';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                    // note First Name could be sent, but its optional and not
                    // part of the front-end.
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetActiveSurveys',
            method: () => {
                return 'survey/active';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetSurveyStatus',
            method: () => {
                return `survey/status`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetSurveyQuestions',
            method: (urlArgs) => {
                return `survey/active${urlArgs.survey_id}/questions`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'survey_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'GetNamedSurveyQuestions',
            method: () => {
                return 'survey/questions';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'name',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'SetSurveyAnswer',
            method: (urlArgs) => {
                return `survey/question${urlArgs.question_id}/answer`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'answer',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [
                {
                    name: 'question_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'CompleteSurvey',
            method: (urlArgs) => {
                return `survey${urlArgs.survey_id}/complete`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'survey_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'ActionComplete',
            method: (urlArgs) => {
                return `player/action/complete/${urlArgs.action_name}`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'action_name',
                    processArgs: (val) => {
                        return val ? val : 'invalid-action-name';
                    },
                },
            ],
        },
        {
            name: 'MRBEnterTicket',
            method: () => {
                return 'ticket/enter';
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'ticket_number',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'entry_method',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'ticket_type',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetDashboard',
            method: () => {
                return 'dashboard';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPlayerPrizes',
            method: () => {
                return 'player/prizes';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'GetPlayerWinnings',
            method: () => {
                return 'winners/player';
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'SubmitSocialMediaClick',
            method: (urlArgs) => {
                return `bonusing/social/${urlArgs.site}`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'site',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'CompleteCustomUrlQualifier',
            method: (urlArgs) => {
                return `bonusing/customurlclicked/${urlArgs.id}`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'id',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'ClaimPromo',
            method: (urlArgs) => {
                return `bonusing/claim/${urlArgs.claim_code}`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'claim_code',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
        },
        {
            name: 'GetPointsHistory',
            method: (urlArgs) => {
                return `player/balances/history`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'page_size',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
                {
                    name: 'startdate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'enddate',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'account_name',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'transaction_type',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'Totals',
                    processArgs: (val) => {
                        return val || 'true';
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'CallExternalEndpoint',
            method: (urlArgs) => {
                return `${urlArgs.base_url}/${urlArgs.endpoint_url}`;
            },
            action: 'external',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [],
            args: [],
            urlArgs: [
                {
                    name: 'base_url',
                    processArgs: (val) => {
                        return val ? val : '';
                    },
                },
                {
                    name: 'endpoint_url',
                    processArgs: (val) => {
                        return val ? val : '';
                    },
                },
            ],
        },
        {
            name: 'CallExternalEndpointWithAuth',
            method: (urlArgs) => {
                return `${urlArgs.base_url}/${urlArgs.endpoint_url}`;
            },
            action: 'external',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'base_url',
                    processArgs: (val) => {
                        return val ? val : '';
                    },
                },
                {
                    name: 'endpoint_url',
                    processArgs: (val) => {
                        return val ? val : '';
                    },
                },
            ],
        },
        {
            name: 'GetTicketActivity',
            method: (urlArgs) => {
                return `query/activity/ticket`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'page',
                    processArgs: (val) => {
                        return val || 1;
                    },
                },
                {
                    name: 'pagesize',
                    processArgs: (val) => {
                        return val || '5';
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'UpdateEmail',
            method: () => {
                return 'player/update';
            },
            action: 'put',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'email',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'old_password',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'UpdatePassword',
            method: () => {
                return 'player/update';
            },
            action: 'put',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'old_password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'password',
                    processArgs: (val) => {
                        return val;
                    },
                },
                {
                    name: 'confirm',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
        {
            name: 'GetGameEngineGameBoards',
            method: (urlArgs) => {
                return `gameengine/games${urlArgs.game_id}/boards`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'GetGameEngineGameWinTypesWithPrizes',
            method: (urlArgs) => {
                return `gameengine/games${urlArgs.game_id}/win_types?with_prizes=true`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'GetGameEngineGameBoard',
            method: (urlArgs) => {
                return `gameengine/games${urlArgs.game_id}/boards${urlArgs.board_id}`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [
                {
                    name: 'game_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
                {
                    name: 'board_id',
                    processArgs: (val) => {
                        return val ? '/' + val : '';
                    },
                },
            ],
        },
        {
            name: 'GetNotifications',
            method: (urlArgs) => {
                return `player/messagecenter/communiques`;
            },
            action: 'get',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'DismissAllNotifications',
            method: (urlArgs) => {
                return `player/messagecenter/acknowledge-all`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [],
            urlArgs: [],
        },
        {
            name: 'DismissNotification',
            method: (urlArgs) => {
                return `player/messagecenter/acknowledge`;
            },
            action: 'post',
            postBuild: (postingData, requestObj) => {
                return requestObj;
            },
            postRequest: (err, res) => {},
            headers: [
                {
                    name: 'X-Auth-Token',
                    processHeader: (val) => {
                        return val;
                    },
                },
                {
                    name: 'X-Auth-Spat',
                    processHeader: (val) => {
                        return val;
                    },
                },
            ],
            args: [
                {
                    name: 'communique_ids',
                    processArgs: (val) => {
                        return val;
                    },
                },
            ],
            urlArgs: [],
        },
    ];
};
